import { MastersActions } from "../action-types/mastersActionTypes";

const initialState = {
  paginationForMaster: "",
  checklistQuestionMasterPagination: "",
  checklistTypeMasterPagination: "",
  checklistMasterPagination: "",
  vesselMasterPagination: "",
  vesselTypeMasterPagination: "",
  vesselMasterData: [],
  vesselTypeMasterData: [],
  checklistMasterData: [],
  checklistTypeMasterData: [],
  departmentMasterData: [],
  roleMasterData: [],
  screenAccessMasterData: [],
  rolePermissionMasterData: [],
  companyData: [],
  userMasterData: [],
  questionChecklistMasterData: [],
  checklistQuestionMasterData: [],
  allChecklistQuestionMasterData: [],
  sendNotificationMasterData: [],
  supportMasterData: [],
  models: {
    AddDepartmentMasterModel: "",
    AddUserMasterModel: "",
    AddQuestionMasterModel: "",
    AddChecklistTypeMasterModel: "",
    AddVesselTypeMasterModel: "",
    AddVesselMasterModel: "",
    AddSendNotificationModel: "",
  },
  EditUserMasterModel: {
    isOpenEditModel: "",
    EditRowDataModel: [],
  },
  EditDepartmentMasterModel: {
    isOpenEditModel: "",
    EditRowDataModel: [],
  },
  EditQuestionMasterModel: {
    isOpenEditModel: "",
    EditRowDataModel: [],
  },
  EditChecklistTypeMasterModel: {
    isOpenEditModel: "",
    EditRowDataModel: [],
  },
  EditVesselTypeMasterModel: {
    isOpenEditModel: "",
    EditRowDataModel: [],
  },
  EditVesselMasterModel: {
    isOpenEditModel: "",
    EditRowDataModel: [],
  },
};

const mastersReducer = (state = initialState, action) => {
  switch (action.type) {
    case MastersActions.SET_PAGINATION_MASTER:
      return {
        ...state,
        paginationForMaster: action.payload,
      };
    case MastersActions.SET_CHECKLIST_QUESTION_MASTER_PAGINATION:
      return {
        ...state,
        checklistQuestionMasterPagination: action.payload,
      };
    case MastersActions.SET_CHECKLIST_TYPE_MASTER_PAGINATION:
      return {
        ...state,
        checklistTypeMasterPagination: action.payload,
      };
    case MastersActions.SET_CHECKLIST_MASTER_PAGINATION:
      return {
        ...state,
        checklistMasterPagination: action.payload,
      };
    case MastersActions.SET_VESSEL_MASTER_PAGINATION:
      return {
        ...state,
        vesselMasterPagination: action.payload,
      };
    case MastersActions.SET_VESSEL_TYPE_MASTER_PAGINATION:
      return {
        ...state,
        vesselTypeMasterPagination: action.payload,
      };
    case MastersActions.SET_VESSEL_MASTER_LIST:
      return {
        ...state,
        vesselMasterData: action.payload,
      };
    case MastersActions.SET_VESSEL_TYPE_MASTERS_LIST:
      return {
        ...state,
        vesselTypeMasterData: action.payload,
      };
    case MastersActions.SET_CHECKLIST_MASTERS_LIST:
      return {
        ...state,
        checklistMasterData: action.payload,
      };
    case MastersActions.SET_CHECKLIST_TYPE_MASTERS_LIST:
      return {
        ...state,
        checklistTypeMasterData: action.payload,
      };
    case MastersActions.SET_DEPARTMENT_MASTER_LIST:
      return {
        ...state,
        departmentMasterData: action.payload,
      };
    case MastersActions.SET_ROLE_MASTER_LIST:
      return {
        ...state,
        roleMasterData: action.payload,
      };
    case MastersActions.SET_SCREEN_ACCESS_MASTER_LIST:
      return {
        ...state,
        screenAccessMasterData: action.payload,
      };
    case MastersActions.SET_ROLE_PERMISSION_MASTER_LIST:
      return {
        ...state,
        rolePermissionMasterData: action.payload,
      };
    case MastersActions.SET_COMPANY_LIST:
      return {
        ...state,
        companyData: action.payload,
      };
    case MastersActions.SET_USER_MASTER_LIST:
      return {
        ...state,
        userMasterData: action.payload,
      };
    case MastersActions.SET_CHECKLIST_QUESTION_MASTERS_LIST:
      return {
        ...state,
        checklistQuestionMasterData: action.payload,
      };
    case MastersActions.SET_ALL_CHECKLIST_QUESTION_MASTERS_LIST:
      return {
        ...state,
        allChecklistQuestionMasterData: action.payload,
      };
    case MastersActions.SET_QUESTION_CHECKLIST_MASTER_LIST:
      return {
        ...state,
        questionChecklistMasterData: action.payload,
      };
    case MastersActions.SET_SEND_NOTIFICATION_MASTER_LIST:
      return {
        ...state,
        sendNotificationMasterData: action.payload,
      };
    case MastersActions.SET_SUPPORT_MASTER_LIST:
      return {
        ...state,
        supportMasterData: action.payload,
      };
    case MastersActions.IS_OPEN_MODELS_ADD_DEPARTMENT_MASTER:
      return {
        ...state,
        models: {
          ...state.models,
          AddDepartmentMasterModel: action.payload,
        },
      };
    case MastersActions.IS_OPEN_MODELS_ADD_USER_MASTER:
      return {
        ...state,
        models: {
          ...state.models,
          AddUserMasterModel: action.payload,
        },
      };
    case MastersActions.IS_OPEN_MODELS_ADD_QUESTION_MASTER:
      return {
        ...state,
        models: {
          ...state.models,
          AddQuestionMasterModel: action.payload,
        },
      };
    case MastersActions.IS_OPEN_MODELS_ADD_CHECKLIST_TYPE_MASTER:
      return {
        ...state,
        models: {
          ...state.models,
          AddChecklistTypeMasterModel: action.payload,
        },
      };
    case MastersActions.IS_OPEN_MODELS_ADD_VESSEL_TYPE_MASTER:
      return {
        ...state,
        models: {
          ...state.models,
          AddVesselTypeMasterModel: action.payload,
        },
      };
    case MastersActions.IS_OPEN_MODELS_ADD_VESSEL_MASTER:
      return {
        ...state,
        models: {
          ...state.models,
          AddVesselMasterModel: action.payload,
        },
      };
    case MastersActions.IS_OPEN_MODELS_ADD_SEND_NOTIFICATION_MASTER:
      return {
        ...state,
        models: {
          ...state.models,
          AddSendNotificationModel: action.payload,
        },
      };
    case MastersActions.IS_OPEN_MODELS_EDIT_USER_MASTER:
      return {
        ...state,
        EditUserMasterModel: {
          ...state.EditUserMasterModel,
          isOpenEditModel: action.payload?.isOpenEditModel,
          EditRowDataModel: action.payload?.EditRowDataModel,
        },
      };
    case MastersActions.IS_OPEN_MODELS_EDIT_DEPARTMENT_MASTER:
      return {
        ...state,
        EditDepartmentMasterModel: {
          ...state.EditDepartmentMasterModel,
          isOpenEditModel: action.payload?.isOpenEditModel,
          EditRowDataModel: action.payload?.EditRowDataModel,
        },
      };
    case MastersActions.IS_OPEN_MODELS_EDIT_QUESTION_MASTER:
      return {
        ...state,
        EditQuestionMasterModel: {
          ...state.EditQuestionMasterModel,
          isOpenEditModel: action.payload?.isOpenEditModel,
          EditRowDataModel: action.payload?.EditRowDataModel,
        },
      };
    case MastersActions.IS_OPEN_MODELS_EDIT_CHECKLIST_TYPE_MASTER:
      return {
        ...state,
        EditChecklistTypeMasterModel: {
          ...state.EditChecklistTypeMasterModel,
          isOpenEditModel: action.payload?.isOpenEditModel,
          EditRowDataModel: action.payload?.EditRowDataModel,
        },
      };
    case MastersActions.IS_OPEN_MODELS_EDIT_VESSEL_TYPE_MASTER:
      return {
        ...state,
        EditVesselTypeMasterModel: {
          ...state.EditVesselTypeMasterModel,
          isOpenEditModel: action.payload?.isOpenEditModel,
          EditRowDataModel: action.payload?.EditRowDataModel,
        },
      };
    case MastersActions.IS_OPEN_MODELS_EDIT_VESSEL_MASTER:
      return {
        ...state,
        EditVesselMasterModel: {
          ...state.EditVesselMasterModel,
          isOpenEditModel: action.payload?.isOpenEditModel,
          EditRowDataModel: action.payload?.EditRowDataModel,
        },
      };
    default:
      return state;
  }
};

export default mastersReducer;
